<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="District Preview"
      id="admin_edit_district_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Edit
      </v-btn>
      <v-btn
        :to="
          '/admin/locations/districts/view/' +
          $route.params.id +
          '/delete'
        "
        small
        rounded
        class="mr-4"
        outlined
        color="red"
      >
        <v-icon left>mdi-trash-can</v-icon> Remove District
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="district.name"
        :icon="'mdi-flag'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1605870956/botswana%20services/website%20assets/map-full_qlxnxa.png'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="Edit districts Form"
      id="admin_edit_district_form"
    ></CardedSectionHeader>
    <AdminDistrictsAdd
      @on-show-loader="show_loader"
      @on-hide-loader="hide_loader"
      :is_editing="true"
      :is_loading="is_loading"
      ref="add_district_form_comp_ref"
      @on-success-edit="on_success_edit"
    >
    </AdminDistrictsAdd>
  </div>
</template>
<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import ViewHeader from "../../../components/ViewHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import AdminDistrictsAdd from "./AdminDistrictsAdd";
import ServerClient from "../../../lib/ServerClient";

export default {
  name: "AdminDistrictsEdit",
  components: {
    CardedSectionHeader,
    ViewHeader,
    CardedDisplay,
    AdminDistrictsAdd,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      district: {
        id: 0,
        name: "",
        short_name: "",
        country: {
            id: 0,
            name: ""
        }
      },
    };
  },
  methods: {
    show_loader() {
      this.$emit("on-show-loader");
    },
    hide_loader() {
      this.$emit("on-hide-loader");
    },
    load_district(){
      ServerClient.Locations.get_district(
      {
        id: this.$route.params.id,
        is_edit: true,
      },
      (res) => {
        this.$emit("on-hide-loader");
        this.district = res;
        var edit = {
            ... res
        };
        delete edit.country;
        this.$refs.add_district_form_comp_ref.fill_edit_district(edit);
      },
      (errors) => {
        this.$emit("on-hide-loader");
        console.log(
          "Errors while loading district details on admin edit districts",
          errors
        );
      }
    );
    },
    on_success_edit(){
      this.load_district();
    }
  },

  computed: {
    view_header_facts() {
      var facts = [
        { text: "Country:", val: this.district.country.name },
      ];
      return facts;
    },
  },

  mounted() {
    var district_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "Admin Edit District",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Districts",
          disabled: false,
          href: "/admin/locations/districts/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/admin/locations/districts/list/view/" + district_id,
        },
        {
          text: "Edit",
          disabled: true,
          href:"/admin/locations/districts/list/view/"+district_id+"/edit" 
        }
      ],
      navbar_cols: 3
    });
    this.load_district();
  },
};
</script>

